module.exports = __webpack_public_path__ + "img/img-titleCoach.27772966.png";